var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"15px"}},[_c('SettingForm',{attrs:{"data":_vm.formData},on:{"sendData":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }